import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";

const slidersImages = document.querySelectorAll(".images-slider");
const slidersTeam = document.querySelectorAll(".team-slider");
const slidersTextMedia = document.querySelectorAll(".text-media-slider");
const slidersTimeline = document.querySelectorAll(".timeline-slider");
const slidersLogos = document.querySelectorAll(".logos-slider");

document.addEventListener("DOMContentLoaded", () => {
    if (slidersImages) {
        slidersImages.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");
            const paginationEl = el.querySelector(".swiper-pagination");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;
            const pagination = paginationEl
                ? { el: paginationEl, clickable: true }
                : undefined;
            const swiper = new Swiper(swiperEL, {
                modules: [Navigation, Pagination],
                speed: 400,
                spaceBetween: 12,
                slidesPerView: 1,
                watchOverflow: true,
                navigation,
                pagination,
                breakpoints: {
                    480: {
                        slidesPerView: 1.5,
                        spaceBetween: 16,
                    },
                    720: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                    1440: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                    },
                },
            });
        });
    }

    if (slidersTeam) {
        slidersTeam.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;
            // eslint-disable-next-line no-new
            new Swiper(swiperEL, {
                modules: [Navigation],
                speed: 400,
                // 13px = the container-grid gutter, so at 4-up the cards land as exact
                // 3-column blocks aligned to the page's 14-col grid (matches the hero).
                spaceBetween: 13,
                slidesPerView: 1.2, // a peek of the next card on smaller screens
                watchOverflow: true,
                navigation,
                breakpoints: {
                    480: { slidesPerView: 2.2 },
                    720: { slidesPerView: 3.2 },
                    1440: { slidesPerView: 4 },
                },
            });
        });
    }

    if (slidersTimeline) {
        slidersTimeline.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;

            // Align the first year column to grid col 2 (== the CSS --tl-inset), so
            // columns + hook sit on col 2–13 like the blocks above. Mirror it after
            // the last slide. Slide widths are CSS (slidesPerView: 'auto').
            // `edge` = inset from the track (max-w-grid) edge to content col 2/13 —
            // the swiper's own offset, small + constant, so wide screens add no huge
            // trailing scroll. `curveX` = col 13 from the viewport left (the hook's
            // vertical), for the dots.
            const geo = () => {
                const grid = Math.min(0.9 * window.innerWidth, 1513);
                const col = (grid - 169) / 14;
                const edge = col + 13;
                const gridLeft = (window.innerWidth - grid) / 2;
                return { edge, col2: gridLeft + edge, curveX: gridLeft + grid - edge };
            };

            // Drop the hook's vertical past the tallest column's bottom (+64px of
            // breathing room), so the bottom line sits clearly below every item's
            // text (--tl-h; 8px = the line offset).
            const setHookHeight = () => {
                let h = 0;
                el.querySelectorAll(".timeline-slide").forEach((s) => {
                    h = Math.max(h, s.offsetHeight);
                });
                if (h) el.style.setProperty("--tl-h", `${Math.round(h - 8 + 64)}px`);
            };

            // Dim the columns that aren't fully on the grid (col 2–13) to 20% — a flat
            // transparency, no gradient — and hide the dot of any column that has
            // scrolled PAST the hook's vertical (col 13), where the line turns down.
            const slides = [...el.querySelectorAll(".timeline-slide")];
            const updateDots = () => {
                const { col2, curveX } = geo();
                slides.forEach((slide) => {
                    const r = slide.getBoundingClientRect();
                    const dot = slide.querySelector(".timeline-slide__dot");
                    if (r.width === 0) {
                        slide.style.opacity = "";
                        return;
                    }
                    // Opacity tracks how much of the column sits in the active band
                    // (col 2–13; on mobile that's ~one column), fully on = 1, off = 0.2,
                    // smooth in between. 8px tolerance so a column that just kisses the
                    // edge still reads as full.
                    const onGrid = Math.min(r.right, curveX + 8) - Math.max(r.left, col2 - 8);
                    const frac = Math.max(0, Math.min(1, onGrid / r.width));
                    slide.style.opacity = (0.2 + 0.8 * frac).toFixed(3);
                    // The dot only shows for the active column(s); hidden as soon as the
                    // column is no longer fully on the grid.
                    if (dot) dot.classList.toggle("is-off-line", frac < 0.95);
                });
            };

            const swiper = new Swiper(swiperEL, {
                modules: [Navigation, Pagination],
                speed: 400,
                spaceBetween: 24, // matches --tl-gap; keeps the peek off the hook line
                slidesPerView: "auto",
                watchOverflow: true,
                resistanceRatio: 0, // hard stop at the ends — no overscroll past the last item
                navigation,
                slidesOffsetBefore: geo().edge,
                slidesOffsetAfter: geo().edge,
            });
            const sync = () => {
                swiper.params.slidesOffsetBefore = geo().edge;
                swiper.params.slidesOffsetAfter = geo().edge;
                swiper.update();
                setHookHeight();
                updateDots();
            };
            // Per-frame updates during the slide animation so the opacity eases with
            // the motion (setTranslate alone only fires once per programmatic slide).
            let raf = 0;
            const tick = () => {
                updateDots();
                raf = requestAnimationFrame(tick);
            };
            swiper.on("resize", sync);
            swiper.on("setTranslate", updateDots);
            swiper.on("transitionStart", () => {
                cancelAnimationFrame(raf);
                tick();
            });
            swiper.on("transitionEnd", () => {
                cancelAnimationFrame(raf);
                updateDots();
            });
            setHookHeight();
            updateDots();
        });
    }

    if (slidersLogos) {
        slidersLogos.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;
            // Partner logo wall: continuous, gentle autoplay + loop (a "trusted by"
            // marquee), several logos per view on desktop, fewer on mobile. Arrows
            // stay for keyboard/pointer control; hovering pauses the drift.
            //
            // Respect prefers-reduced-motion: when set, drop the Autoplay module and
            // its option entirely so the wall is static; the arrows still let a user
            // page through it manually.
            const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            // eslint-disable-next-line no-new
            new Swiper(swiperEL, {
                modules: reduce ? [Navigation] : [Navigation, Autoplay],
                speed: 500,
                spaceBetween: 16,
                slidesPerView: 2,
                loop: true,
                watchOverflow: true,
                ...(reduce
                    ? {}
                    : {
                          autoplay: {
                              delay: 2500,
                              disableOnInteraction: false,
                              pauseOnMouseEnter: true,
                          },
                      }),
                navigation,
                breakpoints: {
                    480: { slidesPerView: 3 },
                    720: { slidesPerView: 4 },
                    1440: { slidesPerView: 5 },
                },
            });
        });
    }

    if (slidersTextMedia) {
        slidersTextMedia.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");
            const paginationEl = el.querySelector(".swiper-pagination");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;
            const pagination = paginationEl
                ? { el: paginationEl, clickable: true }
                : undefined;
            const swiper = new Swiper(swiperEL, {
                modules: [Navigation, Pagination],
                speed: 400,
                spaceBetween: 12,
                slidesPerView: 1,
                watchOverflow: true,
                navigation,
                pagination,
                breakpoints: {
                    480: {
                        slidesPerView: 1.5,
                        spaceBetween: 16,
                    },
                    720: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                    1440: {
                        slidesPerView: 5,
                        spaceBetween: 16,
                    },
                },
            });
        });
    }
});
